import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSG from 'highcharts/modules/solid-gauge';

HighchartsMore(Highcharts);
HighchartsSG(Highcharts);
const ajaxUrl = window.location.pathname;
let phase = 1;
$(() => {
    function getOptionParameterValue() {
        const queryString = window.location.search,
            regex = new RegExp("[?&]option(=([^&#]*)|&|#|$)"), // Create a regular expression to find the parameter and its value
            results = regex.exec(queryString)
        if (results && results[2]) { // If the parameter is found, return its value; otherwise, return null
          return decodeURIComponent(results[2].replace(/\+/g, " "))
        }
        return null
    }
    const acceptedOptionValues =['super', 'ttr', 'retirement'],
        optionParameterValue = getOptionParameterValue()
    if (acceptedOptionValues.includes(optionParameterValue)) {
        const $selectedRadioOption = $(`#${optionParameterValue}`)
        $selectedRadioOption.trigger('click')
        console.log('Reached matched param:', {optionParameterValue, $selectedRadioOption})
    }

    let dash_chart, asset_chart, asset_breakdown_chart
    if ($('input[name="channel"]:checked').length) {
        phase = $('input[name="channel"]:checked').val()
        console.log('Reached input checked condition:', {phase})
    }
    $('input[name="channel"]').on('click', function() {
        phase = $(this).val();
        $('.js-pds').hide().filter("[data-channel='" + phase + "']").show();
        renderDashboardChart();
    });
    $('.js-asset-drilldown-trigger').on('click', function(e) {
        e.preventDefault();
        // table work
        var drill_id = $(this).attr('data-assetid');
        // propagate to charts, the above lines are taken care of by the slices
        var container = document.querySelector('#asset-allocation-chart'),
            chartIndex = container.getAttribute('data-highcharts-chart'),
            chart = Highcharts.charts[chartIndex];
        // get correct slice
        var section = $(chart.series[0].data).filter(function() {
            return $(this).attr('id') == drill_id
        });
        // highchart select
        section.select();
    });
    renderDashboardChart();
    renderAssetChart();
    var chart_data_call;
    var asset_data_call;
    function renderDashboardChart() {
        if ((typeof chart_data_call) != 'undefined') {
            chart_data_call.abort();
        }
        $('.js-dashboard-chart').empty();
        var chart_div_Id = 'dashboard-chart';
        if ($('#' + chart_div_Id).length > 0) {
            var api_url = ajaxUrl + "getChartInvestmentsData?typeId=" + phase;
            chart_data_call = $.getJSON({
                url: api_url,
                success: function(data) {
                    $.each(data.items, function(i, item) {
                        item.tooltip = {
                            valueSuffix: ' %'
                        };
                    });
                    dash_chart = new Highcharts.Chart({
                        chart: {
                            renderTo: chart_div_Id,
                            type: 'column',
                            height: 580
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: ''
                        },
                        xAxis: {
                            lineColor: '#FFFFFF',
                            lineWidth: 2,
                            tickLength: 0,
                            labels: {
                                format: '{value}',
                                y: 25,
                            },
                            dateTimeLabelFormats: {
                                month: '%Y',
                                year: '%Y'
                            },
                            title: {
                                text: 'Year ending 30 June',
                                margin: 15
                            }
                        },
                        yAxis: {
                            gridLineWidth: 0,
                            title: '',
                            labels: {
                                align: "right",
                                format: '{value}%',
                                x: -15,
                            },
                            title: {
                                text: 'Percentage returns',
                                margin: 15
                            }
                        },
                        legend: {
                            enabled: true,
                            borderRadius: 0,
                            borderWidth: 0,
                            itemDistance: 10,
                            padding: 10,
                            align: "center",
                            margin: 20,
                            squareSymbol: false,
                            symbolWidth: 34,
                            symbolHeight: 14,
                            symbolRadius: 0,
                            symbolPadding: 10,
                            itemStyle: {
                                lineHeight: '14px'
                            }
                        },
                        plotOptions: {
                            line: {
                                marker: {
                                    enabled: false,
                                },
                                lineWidth: 3
                            },
                            series: {
                                events: {
                                    legendItemClick: function(e) {
                                        e.preventDefault();
                                    }
                                }
                            },
                            column: {
                                groupPadding: 0,
                                color: '#672AB7'
                            },
                        },
                        series: data,
                        tooltip: {
                            crosshairs: true,
                            borderWidth: 1,
                            borderColor: '#150925',
                            backgroundColor: '#150925',
                            shadow: false,
                            shared: true,
                            useHTML: true,
                            padding: 14,
                            style: {
                                fontFamily: 'Nunito Sans, Arial, Helvetica, sans-serif'
                            },
                            formatter: function() {
                                var s = '<div class="highcharts-tooltip-title">' + this.x + '</div><table class="table-blank">';
                                var t = 0;
                                $.each(this.points, function(i, point) {
                                    if (point.y) {
                                        var l = '<tr><td><b>' + point.series.name + ':</b></td>';
                                        var v = '<td></b>' + Highcharts.numberFormat(point.y, 2, '.', ',') + '%</b></td></tr>';
                                        s += l + v;
                                        t += Number(point.y);
                                    }
                                });
                                return s;
                            }
                        }
                    });
                }
            });
        }
    }
    function renderAssetChart() {
        if ((typeof asset_data_call) != 'undefined') {
            asset_data_call.abort();
        }
        $('.js-allocation-table').hide();
        var asset_table_div_Id = 'asset-allocation-table-' + phase;
        $('#' + asset_table_div_Id).show();
        $('.js-asset-chart').empty();
        $('.js-drilldown-chart').empty();
        var asset_chart_div_Id = 'asset-allocation-chart';
        if ($('#' + asset_chart_div_Id).length > 0) {
            var api_url = ajaxUrl + "getAssetAllocationData?typeId=" + phase;
            asset_data_call = $.ajax({
                dataType: "json",
                url: api_url,
                success: function(msg) {
                    asset_chart = Highcharts.chart('asset-allocation-chart', {
                        chart: {
                            type: 'pie',
                            height: 580,
                            spacingTop: 0,
                            spacingBottom: 0,
                            spacingLeft: 0,
                            spacingRight: 0,
                            events: {
                                load: function() {
                                    // first select
                                    this.series[0].data[0].select();
                                }
                            }
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: ''
                        },
                        legend: {
                            verticalAlign: 'bottom',
                            enabled: true,
                            borderWidth: 0,
                            margin: 10,
                            itemMarginBottom: 2,
                            symbolWidth: 11,
                            symbolHeight: 11,
                            symbolRadius: 0,
                            symbolPadding: 10,
                        },
                        tooltip: {
                            useHTML: true,
                            padding: 0,
                            borderWidth: 0,
                            shadow: false,
                            shared: true,
                            headerFormat: '<span class="ipo-chart__title" style="display:block;text-align:center;">{point.key}</span>',
                            pointFormat: '<span class="ipo-chart__number" style="display:block;color:{point.color};text-align:center;">{point.y}%</span>',
                            positioner: function(labelWidth, labelHeight) {
                                return {
                                    x: (this.chart.plotWidth / 2) - (labelWidth / 2),
                                    y: (this.chart.plotHeight / 2) - (labelHeight / 2)
                                };
                            }
                        },
                        pane: {
                            size: '100%'
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                size: '100%',
                                dataLabels: {
                                    enabled: false
                                },
                                showInLegend: true
                            },
                            series: {
                                point: {
                                    events: {
                                        select: function() {
                                            var drilldown = this.drilldown;
                                            var options;
                                            options = {
                                                'series': drilldown.series,
                                                'max': drilldown.max,
                                                'background': drilldown.background
                                            };
                                            $('.js-asset-drilldown-title').html(drilldown.name);
                                            $('.js-asset-drilldown-trigger').removeClass('hover').parents('tr').removeClass('hover');
                                            $('.js-asset-drilldown-trigger').filter("[data-assetid='" + this.id + "']").addClass('hover').parents('tr').addClass('hover');
                                            $('.js-asset-drilldown-table').hide();
                                            $('.js-asset-drilldown-table').filter("[data-assetid='" + this.id + "']").show();
                                            renderAssetBreakdown(options);
                                        }
                                    }
                                }
                            }
                        },
                        series: [{
                            name: 'Asset Allocation',
                            data: msg,
                            innerSize: '50%',
                            events: {
                                legendItemClick: function(e) {
                                    e.preventDefault();
                                }
                            }
                        }]
                    });
                }
            });
        }
    }
    function renderAssetBreakdown(options) {
        asset_breakdown_chart = Highcharts.chart('asset-drilldown-chart', {
            chart: {
                type: 'solidgauge',
                height: 510,
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            legend: {
                verticalAlign: 'bottom',
                enabled: true,
                borderWidth: 0,
                itemMarginBottom: 0,
                symbolHeight: 3,
                symbolWidth: 3,
                symbolRadius: 5,
                symbolPadding: 10,
                margin: 10,
                useHTML: true,
                itemStyle: {
                    lineHeight: "24px"
                }
            },
            tooltip: {
                useHTML: true,
                padding: 0,
                borderWidth: 0,
                shadow: false,
                shared: true,
                headerFormat: '<span class="ipo-chart__title" style="display:block;text-align:center;">{point.key}</span>',
                pointFormat: '<span class="ipo-chart__number" style="display:block;color:{point.color};text-align:center;">{point.y}%</span>',
                positioner: function(labelWidth, labelHeight) {
                    return {
                        x: (this.chart.plotWidth / 2) - (labelWidth / 2),
                        y: (this.chart.plotHeight / 2) - (labelHeight / 2)
                    };
                }
            },
            pane: {
                startAngle: 0,
                endAngle: 360,
                size: '95%',
                background: options.background
            },
            yAxis: {
                min: 0,
                max: options.max,
                tickPositions: []
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false
                    },
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true,
                    showInLegend: true
                },
                series: {
                    events: {
                        legendItemClick: function(e) {
                            e.preventDefault();
                        }
                    }
                }
            },
            series: options.series
        });
        asset_breakdown_chart.redraw();
    }
});
Array.prototype.max = function() {
    return Math.max.apply(null, this);
};
Array.prototype.min = function() {
    return Math.min.apply(null, this);
};
(function() {
    var D = new Date('2011-06-02T09:34:29+02:00');
    if (!D || +D !== 1307000069000) {
        Date.fromISO = function(s) {
            var day, tz,
                rx = /^(\d{4}\-\d\d\-\d\d([tT ][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/,
                p = rx.exec(s) || [];
            if (p[1]) {
                day = p[1].split(/\D/);
                for (var i = 0, L = day.length; i < L; i++) {
                    day[i] = parseInt(day[i], 10) || 0;
                }
                day[1] -= 1;
                day = new Date(Date.UTC.apply(Date, day));
                if (!day.getDate())
                    return NaN;
                if (p[5]) {
                    tz = (parseInt(p[5], 10) * 60);
                    if (p[6])
                        tz += parseInt(p[6], 10);
                    if (p[4] == '+')
                        tz *= -1;
                    if (tz)
                        day.setUTCMinutes(day.getUTCMinutes() + tz);
                }
                return day;
            }
            return NaN;
        };
    } else {
        Date.fromISO = function(s) {
            return new Date(s);
        };
    }
})(jQuery);
